import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import NotFound from '@rsos/components/capstone/ErrorBoundary/NotFound';
import { Keywords } from './keywords/Keywords';

export const KeywordManagementRouter = () => {
  return (
    <Routes>
      <Route path="" element={<Navigate to="triggers" />} />
      <Route path="triggers" element={<Keywords />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
